module.exports = __webpack_public_path__ + "fontawesome-webfont.e6cf7c6ec7c2d6f670ae.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-social/assets/fonts/fontawesome-webfont.woff2?v=4.6.3
// module id = 688
// module chunks = 2